import { Flex, Text } from '@chakra-ui/react'

export function ResultsSummary({ totalPedidos, totalItens, totalPecas }) {
  // Formatar a quantidade de peças com separadores de milhar
  const pecasFormatadas = totalPecas.toLocaleString('pt-BR')

  return (
    <Flex flexDirection="column">
      <Text fontSize="13px" fontWeight="bold" color="#313E44">
        Resultados: {totalPedidos} pedido(s) encontrado(s)
      </Text>
      <Text fontSize="12px" color="#313E44">
        Total de Peças: {pecasFormatadas}
      </Text>
    </Flex>
  )
}
